export default __webpack_public_path__ + "static/media/Vest of the Ghost of the Veldt.3743f10a.jpg";